import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "source-company" }
const _hoisted_3 = { class: "company" }
const _hoisted_4 = { class: "target-company" }
const _hoisted_5 = { class: "note" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = _resolveComponent("Image")
  const _component_ShCompanySearch = _resolveComponent("ShCompanySearch")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "modal-to": "#sh-companies",
    max_width: "48rem",
    centered: false,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => [
      _createTextVNode(" Merge \"" + _toDisplayString($data.company.name) + "\" with... ", 1 /* TEXT */)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("label", null, "Source", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Image, {
              src: $data.company.logo_url,
              placeholder: "assets/company-placeholder.png",
              size: "3rem"
            }, null, 8 /* PROPS */, ["src"]),
            _createTextVNode(" " + _toDisplayString($data.company.name), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("label", null, "Target", -1 /* HOISTED */)),
          _createVNode(_component_ShCompanySearch, {
            ref: "shc_ddown",
            modelValue: $data.shared_company_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.shared_company_id) = $event)),
            disabled: $data.loading,
            "exclude-ids": [$data.company.id],
            required: "",
            placeholder: "Select target company"
          }, null, 8 /* PROPS */, ["modelValue", "disabled", "exclude-ids"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[3] || (_cache[3] = _createElementVNode("b", null, "*Note:", -1 /* HOISTED */)),
          _cache[4] || (_cache[4] = _createTextVNode(" All data from ")),
          _createElementVNode("strong", null, _toDisplayString($data.company.name), 1 /* TEXT */),
          _cache[5] || (_cache[5] = _createTextVNode(" will be moved into the target company. This action cannot be undone. "))
        ])
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, {
        disabled: $data.loading,
        onClick: $options.close
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"]),
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$options.can_submit,
        loading: $data.loading,
        onClick: $options.submit
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode(" Merge ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "loading", "onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClickOutside"]))
}